import React from 'react'

const InstitutionStatus = () => {
  return (
    <div>InstitutionStatus</div>
  )
}

export default InstitutionStatus